import { StockDocumentDetailsEdit } from "./StockDocumentDetailsEdit"
export  * from "./CommunicationSection"

export const StockDocumentDetailsEditSection = StockDocumentDetailsEdit



// WEBPACK FOOTER //
// ./src/project/sections/index.ts